import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class MatPaginatorIntlCro extends MatPaginatorIntl {
    constructor() {
        super();
        // this.nextPageLabel = ' My new label for next page';
        // this.previousPageLabel = ' My new label for previous page';
        this.itemsPerPageLabel = 'Rows per page:';
      }
}